import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MatchDetailLive } from '../models/match-data.models';
import { ParamsModel } from '../models/params.model';
import { environment } from '../../../../environments/environment';
import { TranslationService } from '../../../services/translation.service';
import { LocalStorageService } from '../../../services/localstorage.service';
import { SportsService } from '../../../services/sport.service';
import { GenericService } from '../../../services/generic.services';

@Injectable({
  providedIn: 'root',
})
export class MatchDataService {
  private urlAPI = environment.API;
  protected urlWidget = environment.urlWidgets;
  protected profile = '8nq2ghpoouzulmy';
  protected version = '3D';
  private matchRealTimeData = 'matchRealTimeData';
  private matchLineUp = 'matchLineUpTeam';
  private matchH2H = 'matchH2H';
  private teamById = 'getTeamById';

  constructor(
    private readonly translatorService: TranslationService,
    private readonly lsService: LocalStorageService,
    private readonly sportsServices: SportsService,
    private http: HttpClient,
    private genericServices: GenericService
  ) {}

  /***
   * Obtain statics and incidents of the match selected
   */
  getMatchDetailSelected(
    params: ParamsModel,
    hasSport?: any
  ): Observable<MatchDetailLive> {
    let sport = hasSport ? hasSport : params.sport;

    sport = sport === 'Favoritos' ? 'Futbol' : sport;
    return this.http.post<any>(
      `${this.urlAPI}${
        this.matchRealTimeData
      }${sport}/${this.translatorService.getCurrentLanguage()}/${params.id}/${
        params.idHome
      }/${params.idAway}`,
      {
        favoriteTeams: this.lsService.getFavoriteFromLocal('TEAM'),
        dateUser: this.genericServices.getCurrentTimeUnix(),
        timeZoneUser: this.genericServices.guessTimezone(),
        date: params.date,
        idCompetition: params.idCompetition,
      }
    );
  }

  /***
   * Obtain Lineup home and away of the match selected
   */
  getLineUpTeams(params: ParamsModel): Observable<any> {
    return this.http.get<any>(
      `${this.urlAPI}${this.matchLineUp}${
        params.sport
      }/${this.translatorService.getCurrentLanguage()}/${params.id}`
    );
  }

  /**
   * URL MatchTracker
   */
  getUrlMatchTracker(params: ParamsModel): string {
    const sport = this.sportsServices.searchSport(params.sport).tracker;
    return `${this.urlWidget}${this.translatorService.getCurrentLanguage()}/${
      this.version
    }/${sport}?profile=${this.profile}&uuid=${params.id}`;
  }

  /***
   * Obtain all info H2H between two teams on match
   */
  getH2HMatch(params: ParamsModel): Observable<any> {
    return this.http.post<any>(
      `${this.urlAPI}${this.matchH2H}${
        params.sport
      }/${this.translatorService.getCurrentLanguage()}/${params.id}`,
      {
        timeZoneUser: this.genericServices.guessTimezone(),
      }
    );
  }

  /***
   * Obtain info team by id
   */
  getTeamData(params: ParamsModel, id: string): Observable<any> {
    return this.http.get<any>(
      `${this.urlAPI}${this.teamById}${
        params.sport
      }/${this.translatorService.getCurrentLanguage()}/${id}`
    );
  }
}
